import { render, staticRenderFns } from "./BioDataNav.vue?vue&type=template&id=0d44a1e9&scoped=true"
import script from "./BioDataNav.vue?vue&type=script&lang=js"
export * from "./BioDataNav.vue?vue&type=script&lang=js"
import style0 from "./BioDataNav.vue?vue&type=style&index=0&id=0d44a1e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d44a1e9",
  null
  
)

export default component.exports